import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Home, ArrowLeft, FileText } from "lucide-react";
import { BlogManager } from "@/components/admin/BlogManager";

const AdminBlogManagement = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="glass-card border-b border-border/50 sticky top-0 z-50 backdrop-blur-xl">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link to="/admin">
                <Button variant="ghost" size="icon">
                  <ArrowLeft className="h-5 w-5" />
                </Button>
              </Link>
              <div className="flex items-center gap-2">
                <FileText className="h-6 w-6 text-primary" />
                <h1 className="text-2xl font-bold gradient-digital bg-clip-text text-transparent">
                  Blog Management
                </h1>
              </div>
            </div>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <Home className="h-4 w-4 mr-2" />
                Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-6 py-8 flex-1">
        {/* Welcome Section */}
        <div className="mb-8">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="gradient-digital bg-clip-text text-transparent">Content Management</span>
          </h2>
          <p className="text-lg text-muted-foreground">Create, edit, and manage blog posts for the platform</p>
        </div>

        {/* Blog Manager Component */}
        <div className="glass-card p-8 rounded-2xl border border-border/50">
          <BlogManager />
        </div>
      </div>
    </div>
  );
};

export default AdminBlogManagement;
